import { observable } from 'mobx'
import Api from '@api/team'
import { getPropertyId } from '@util'

class Store {
  @observable visible = false
  @observable inputSearch = ''
  @observable list = []
  @observable filterList = []
  compositionStatus = false

  setStoreData = params => {
    Object.keys(params).forEach(key => {
      this[key] = params[key]
    })

    if (!this.compositionStatus) {
      this.onSearch()
    }
  }

  openModal = () => {
    this.visible = true
    this.getList()
  }

  getList = async (params = {}) => {
    const {
      data: { list },
      success
    } = await Api.groupList({
      // name: this.inputSearch,
      ...params,
      perPage: 999,
      page: 1,
      propertyId: getPropertyId()
    })
    if (success) {
      this.list = [...list] || []
      this.onSearch()
    }
  }

  onApply = async id => {
    const { success } = await Api.applyGroup({ groupId: id })
    if (success) {
      this.getList()
    }
  }

  onSearch = () => {
    if (this.inputSearch) {
      this.filterList = this.list.filter(
        item => item.name.indexOf(this.inputSearch) > -1
      )
    } else {
      this.filterList = [...this.list]
    }
  }

  onCompositionStart = () => {
    this.compositionStatus = true
  }

  onCompositionEnd = () => {
    this.compositionStatus = false
    this.onSearch()
  }
}

export default Store
